<template>
  <v-app>

    <TopNavBar
    v-on:sidebarEmit="updateSidebarStatus($event)"
    :mini="mini"
    :enabled="loggedIn"
    :userDb="this.userDb"
    ></TopNavBar>

    <SideNavBar
    v-on:signOut="updateLoginStatus($event)"
    v-on:sidebarEmit="updateSidebarStatus($event)"
    :navItems="items"
    :mini="mini"
    :enabled="loggedIn"
    :userDb="this.userDb"
    :orgDb="this.orgDb"
    ></SideNavBar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import SideNavBar from './components/NavBar/SideNavBar.vue'
import TopNavBar from './components/NavBar/TopNavBar.vue'
import firebase from '@/fb';
import Toast from './plugins/customToast.js';

export default {
  name: 'App',  

  components: {
    SideNavBar,
    TopNavBar
  },
  methods: {
    updateLoginStatus(value){
      this.loggedIn = value;
      console.log("Caught!"); // eslint-disable-line no-console
    },
    updateSidebarStatus(value){
      console.log("Caught!"); // eslint-disable-line no-console
      this.mini = value;
    },
    async reloadFirebase(){
      this.getUser();
    },
    async setDbDataFromParams(){
      this.userDb = this.$route.params.userDb;
      this.orgDb = this.$route.params.orgDb;
    },
    //Firebase call to get user database item
    async getUser(){
      var that = this;
      //Initialise the snapshot listener (should keep our users DB updated throughout)
      firebase.db.collection("users").where("uid", "==", this.$route.params.user.uid)
      .onSnapshot(querySnapshot => {
        //There should only every be one return with a uid (It is unique to each user)
            querySnapshot.forEach(doc => {
              const data = {
                uid: doc.data().uid,
                displayname: doc.data().displayname,
                firstname: doc.data().firstname,
                surname: doc.data().surname,
                photo: doc.data().photo,
                email: doc.data().email,
                treatments: doc.data().treatments,
                orgid: doc.data().orgid,
                orgadmin: doc.data().orgadmin,
                interests: doc.data().interests,
                location: doc.data().location,
                online: doc.data().online,
                activity: doc.data().activity,
                premium: doc.data().premium,
                faveTreatments: doc.data().faveTreatments,
                faveCases: doc.data().faveCases
              }            
              that.userDb =  data;
            })
            if (!that.orgDb || !that.orgDb.id){
              that.getOrganisation();
            }
        })
    },    
    //Firebase call to get organisation database item
    async getOrganisation(){
      //Initialise the snapshot listener (should keep our organisation DB updated throughout)
      firebase.db.collection("organisations").where("id", "==", this.userDb.orgid)
      .onSnapshot(querySnapshot => {
        //There should only every be one return with a uid (It is unique to each user)
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.data().id,
            name: doc.data().name,
            bio: doc.data().bio,
            location: doc.data().location,
            users: doc.data().users,
            maxUsers: doc.data().maxUsers,
            treatments: doc.data().treatments
          }
          this.orgDb =  data;
        })
      })
    }
  },
  mounted() {
    //Always load the params by repushing the route? We catch it before it has loaded and then push the correct params (updated)
    //This may not be necessary but do more investigation into it in our future Trello call
    // this.$router.beforeEach((to, from, next) => {
    //   if (to.name !== "LoadingScreen" && to.name !== "DashboardPage") next({ name: to.name, params: { user: this.$route.params.user, loggedInStatus: this.$route.params.loggedInStatus, userDb: this.userDb, orgDb: this.orgDb} })
    //   else next()
    // })
  },
  watch: {
    $route(to, from){
      //React to route changes
      if (from.name === "LoadingScreen" && to.name === "DashboardPage"){
        this.loggedIn = this.$route.params.loginStatus;
        this.reloadFirebase(); //Could remove the need to reload the firebase if we prop them in and just save the params to 'userDB, orgDB etc'

        Toast.fire({  icon: 'success',  title: `Logged in as: ${this.currentUser.email}!`});

      }
    }
  },
  computed: {
      currentUser(){
        return this.$route.params.user;
      }
  },
  data: () => ({
      items: [
        { title: 'Home', icon: 'mdi-view-dashboard', route: { path: '/dashboardPage', name: 'DashboardPage' } },
        { title: 'My Treatments', icon: 'mdi-file-account', route: { path: '/myTreatmentsPage', name: 'MyTreatmentsPage' } },
        { title: 'Community Treatments', icon: 'mdi-account-group', route: { path: '/communityTreatmentsPage', name: 'CommunityTreatmentsPage' } },
        { title: 'Medicine Reference', icon: 'mdi-pill', route: { path: '/medicineReferencePage', name: 'MedicineReferencePage' } },
        { title: 'Dental Articles', icon: 'mdi-newspaper', route: { path: '/dentalArticlePage', name: 'DentalArticlePage' } },
      ],
      mini: true,
      loggedIn: false,
      userDb: {},
      orgDb: {}
  }),
};
</script>

<style scoped>
    
</style>
